export default __webpack_public_path__ + "b65e8b127f462cf20f3c96a43e48b1bb.png";